import { useViewTypeByNameAtom } from './atoms'
import { useViewStateScope } from './view-state-scope'
import type { Scope } from '../types'

export const useViewStateType = (scope: Scope | undefined = undefined) => {
  const { viewType } = useViewTypeByNameAtom(useViewStateScope(scope).type)
  return viewType
}
